import { render, staticRenderFns } from "./ClaimsCoveredTableCard.vue?vue&type=template&id=c62a1b42&scoped=true"
import script from "./ClaimsCoveredTableCard.vue?vue&type=script&lang=ts"
export * from "./ClaimsCoveredTableCard.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsCoveredTableCard.vue?vue&type=style&index=0&id=c62a1b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62a1b42",
  null
  
)

export default component.exports